import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ReverseProgressBar.module.css';

function ReverseProgressBar({ duration, onComplete, onClick, content, loading }) {
  const [progress, setProgress] = useState(100);
  const requestRef = useRef();
  const startRef = useRef();
  const { t } = useTranslation();

  const animate = (timestamp) => {
    if (!startRef.current) startRef.current = timestamp;
    const elapsed = timestamp - startRef.current;

    const percentage = Math.max(0, 100 - (elapsed / duration) * 100);
    setProgress(percentage);

    if (elapsed < duration) {
      requestRef.current = requestAnimationFrame(animate);
    } else {
      onComplete?.();
    }
  };

  useEffect(() => {
    requestRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(requestRef.current);
  }, [duration]);

  return (
    <div
      className={`${styles.Container} ${loading ? styles.Loading : ''}`}
      onClick={() => onClick()}>
      <div
        className={styles.Progress}
        style={{
          width: `${progress}%`
        }}
      />
      <span className={styles.Content}>{content}</span>
    </div>
  );
}

export default ReverseProgressBar;
